import { IntegrationService } from '../../../../../../services/exports/Constants';

export default {
  title: 'Intégrations',
  services: {
    [IntegrationService.Tabless]: 'Tabless',
    [IntegrationService.WinOrder]: 'WinOrder',
    [IntegrationService.ExpertOrder]: 'ExpertOrder',
    [IntegrationService.Deliverect]: 'Deliverect',
    [IntegrationService.Liefersoft]: 'Liefersoft',
    [IntegrationService.Hubrise]: 'HubRise',
  },
  labels: {
    no_integrations: "{{company}} n'a aucune intégration configurée.",
  },
  buttons: {
    add_integration: 'Ajouter une intégration',
  },
  toasts: {
    error: "Échec de l'enregistrement des modifications",
    success: 'Modifications enregistrées',
    load_error: 'Échec du chargement des intégrations',
  },
};
